import companyService from "../../services/company.service";


    export const state ={
        totalPages: 0,

        companies:[],
        actions_company:[],
        companies_by_actions:[],
        type_company_distribution:[],
        company_type_distribution_labels:[],

        company_type_actions:[],
        company_type_actions_labels:[],

        top_company_actions:[],
        top_company_actions_labels:[],

        companies_intention:[],
        companies_intention_labels:[],

        companies_response:[],
        companies_response_labels:[],


    }
    export const actions = {
        fetch_companies({commit}, payload){
            return  companyService.get_companies(payload).then(
                data => {            
                         
                    commit ('SET_COMPANIES', data.data);
                    return Promise.resolve(data);
                }, error => {
                    commit('AssetsFailed');
                    return Promise.reject(error);
                }
            );
        },

        fetch_action_by_company({commit},year_id){
            return companyService.action_by_company(year_id).then(
                data => {
                    commit('SET_ACTION_BY_COMPANY', data.data);
                }, error => {
                    return Promise.reject(error)
                }
            )
        },

        async fetchActionsByCompanies({ commit }, yearOrRange) {
            try {
                let yearParam;
                if (Array.isArray(yearOrRange)) {
                    yearParam = `${yearOrRange[0]}-${yearOrRange[1]}`;
                } else {
                    yearParam = yearOrRange;
                }
        
                await companyService.actions_by_company(yearParam).then(
                    response => {
                        
                        commit('setCompaniesActionsData', response.data);
                    }
                )
                
            } catch (error) {
                console.error('Error fetching actions by year:', error);
            }
        },
        async fetch_company_type_distribution({ commit }) {
            try {
             
                
                await companyService.company_type_distribution().then(
                    response => {
                            
                        commit('SET_COMPANY_TYPE_DISTRIBUTION', response);
                    }
                )
                
            } catch (error) {
                console.error('Error fetching actions by year:', error);
            }
        },
        

        async fetch_company_type_actions({ commit }, yearOrRange) {
            try {
                let yearParam;
                if (Array.isArray(yearOrRange)) {
                    yearParam = `${yearOrRange[0]}-${yearOrRange[1]}`;
                } else {
                    yearParam = yearOrRange;
                }
        
                await companyService.company_type_actions(yearParam).then(
                    response => {
                        
                        commit('SET_TYPE_COMPANY_ACTIONS', response);
                    }
                )
                
            } catch (error) {
                console.error('Error fetching actions by year:', error);
            }
        },

        async fetchTopCompanyActionsByYear({ commit }, yearOrRange) {
            try {
                let yearParam;
                if (Array.isArray(yearOrRange)) {
                    yearParam = `${yearOrRange[0]}-${yearOrRange[1]}`;
                } else {
                    yearParam = yearOrRange;
                }
        
                await companyService.top_company_actions(yearParam).then(
                    response => {
                        
                        commit('SET_TOP_COMPANY_ACTIONS', response);
                    }
                )
                
            } catch (error) {
                console.error('Error fetching actions by year:', error);
            }
        },
        async fetchCompanyIntentionsByYear({ commit }, yearOrRange) {
            try {
                let yearParam;
                if (Array.isArray(yearOrRange)) {
                    yearParam = `${yearOrRange[0]}-${yearOrRange[1]}`;
                } else {
                    yearParam = yearOrRange;
                }
        
                await companyService.company_by_intention(yearParam).then(
                    response => {
                        
                        
                        commit('SET_COMPANY_BY_INTENTIONS', response);
                    }
                )
                
            } catch (error) {
                console.error('Error fetching actions by year:', error);
            }
        },
        async fetchCompanyResponsesByYear({ commit }, yearOrRange) {
            try {
                let yearParam;
                if (Array.isArray(yearOrRange)) {
                    yearParam = `${yearOrRange[0]}-${yearOrRange[1]}`;
                } else {
                    yearParam = yearOrRange;
                }
        
                await companyService.company_by_response(yearParam).then(
                    response => {                        
                        
                        commit('SET_COMPANY_BY_RESPONSES', response);
                    }
                )
                
            } catch (error) {
                console.error('Error fetching actions by year:', error);
            }
        },

    }
    export const mutations = {
        SET_COMPANIES(state, payload){
            state.companies = payload.data
            state.totalPages = payload.last_page; 

        },
        SET_PAYLOAD(state, payload){
            state.payload = payload
        },
        SET_ACTION_BY_COMPANY(state, payload){
            state.actions_company = payload
        },
        AssetsFailed(){

        },

        SET_COMPANY_TYPE_DISTRIBUTION(state, data){
            
            state.type_company_distribution = data.data
            state.company_type_distribution_labels = data.labels
            
        },

        setCompaniesActionsData(state,data){
            
            state.companies_by_actions = data
        },

        SET_TOP_COMPANY_ACTIONS(state, data){
            
            state.top_company_actions = data.data
            state.top_company_actions_labels = [...data.labels]
            
        },
        SET_COMPANY_BY_INTENTIONS(state, data){
            
            state.companies_intention = data.series
            state.companies_intention_labels = data.labels
            
        },
        SET_COMPANY_BY_RESPONSES(state, data){
            
            state.companies_response = data.series
            state.companies_response_labels = data.labels
            
        },

        SET_TYPE_COMPANY_ACTIONS(state,data){
            state.company_type_actions = data.data
            state.company_type_actions_labels = data.labels

        }
    }

    export const getters = {

        get_total_pages: (state) => state.totalPages,

        get_companies(state){
            return state.companies
        },
        get_companies_by_actions(state){
            return state.companies_by_actions
        },
        get_company_type_distribution(state){
            return state.type_company_distribution;
        },
        get_company_type_distribution_labels(state){
            return state.company_type_distribution_labels
        },
        get_company_type_actions(state){
            return state.company_type_actions;
        },
        get_company_type_actions_labels(state){
            return state.company_type_actions_labels
        },
        get_company_by_intentions(state){
            
            return state.companies_intention;
        },
        get_company_by_intentions_labels(state){
            return state.companies_intention_labels
        },
        get_company_by_responses(state){
            
            return state.companies_response;
        },
        get_company_by_responses_labels(state){
            return state.companies_response_labels
        },

        get_top_company_action(state){
            return state.top_company_actions
        },
        get_top_company_action_labels(state){            

            return state.top_company_actions_labels
        }
       
    }


